import { render, staticRenderFns } from "./TicketBlockChipFilter.vue?vue&type=template&id=d2b90868"
import script from "./TicketBlockChipFilter.vue?vue&type=script&lang=js"
export * from "./TicketBlockChipFilter.vue?vue&type=script&lang=js"
import style0 from "./TicketBlockChipFilter.vue?vue&type=style&index=0&id=d2b90868&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports